import { render, staticRenderFns } from "./CorporateIdentifierTypeTB.vue?vue&type=template&id=333a9739&"
import script from "./CorporateIdentifierTypeTB.vue?vue&type=script&lang=js&"
export * from "./CorporateIdentifierTypeTB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('333a9739')) {
      api.createRecord('333a9739', component.options)
    } else {
      api.reload('333a9739', component.options)
    }
    module.hot.accept("./CorporateIdentifierTypeTB.vue?vue&type=template&id=333a9739&", function () {
      api.rerender('333a9739', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/routing/CorporateIdentifierTypeTB.vue"
export default component.exports